export default {
    maps: {
        errorMessages: {
            export: "Error exporting data",
            noDeviceFound: "No matching devices found",
            fetchRadios: "Error retrieving radio data",
            fetchRadiosAndTowers: "Error retrieving radio and base station data",
            fetchRadio: "Error retrieving radio data for: {id}",
            fetchTower: "Error retrieving base station data for: {id}",
            fetchRoutes: "Error retrieving route data for: {id}",
            towersCreateSetMaxIds: 'Too many base stations selected. A max of {cnt} base stations can be selected when creating a set',
            radiosCreateSetMaxIds: 'Too many radios selected. A max of {cnt} radios can be selected when creating a set',
            fetchBuddyOrds: "Error in fetching buddies or ord's info"
        },
        controls: {
            baseStations: {
                name: "Base Station Health",
                healthStatistic: "Health Statistics",
                alarmState: "Alarm State",
                ackCount: "Acks",
                messageDuplicateCount: "Duplicate Buddy Messages",
                messageBuddyCount: "Unique Buddy Messages",
                messageInboundCount: 'Downlink Commands Received',
                messageOutboundCount: 'Downlink Commands Queued',
                uplinkCount: "Uplink Message Sent",
                towerTransmit: "Base Station Transmit Count",
                transmitSlot: 'Transmit Slot',
                singleRouteRadioCount: 'Daily Single Uplink Routes',
                tooltip: 'Disabled for Best Base Station Heard statistic',
                rniStatus:'RNI Status'
            },
            radios: {
                healthStatistic: "Health Statistics",
                snrDaily: "SNR Last Day",
                towersHeardDaily: "Base Stations Heard Last Day",
                routeCountDaily: "Uplink Route Last Day",
                alarmState: "Alarm State",
                buddySupportState: "Buddy Support State",
                bestTowerHeard: "Best Base Station Heard",
                activeAlarmsCounts: 'Active Alarm Counts',
                arqivaTitles: {
                    routeCountDaily: "Uplink Route",
                    towersHeardDaily: "Base Stations Heard",
                    snrDaily: 'Uplink Endpoint SNR'
                },
                receiveFrequency: "Receive Frequency",
                l2ACKSuccess: "L2Ack Success %",
                l2ACKThroughput: "L2Ack Throughput %",
                outageTracking: "Outage Tracking",
                outageLevels: {
                    restored: "Restored",
                    "30M": "30M",
                    "1HR": "1HR",
                    "12HR": "12HR",
                    "24HR": "24HR",
                    "72HR+": "72HR+"
                }
            },
            baseStationFilter: 'Base Station Filter',
            radioFilter: 'Radio Filter',
            lastHeard: "Last Heard",
            stale: "Stale",
            na: "NA",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            zoomExtents: "Zoom to Fit",
            export: "Export Data",
            selectByPolygon: "Select by Polygon",
            selectByDrawing: "Select by Drawing",
            clearDrawingSelected: "Clear Drawing/Selected",
            selectHelp: "Select Help",
            addToSet: "Add Selected Items To Set",
            createSet: "Create Set From Selected Items"
        },
        clickToDisplayMap: {
            tower: "Click to display base station map",
            radio: "Click to display radio map"
        },
        loading: "Loading...",
        dots: "Dots",
        sectors: "Sectors",
        routes: "Routes",
        searchPlaceholder: "Search in Map...",
        searchPlaceholderExact: "Exact Search in Map...",
        detailMapSearchPlaceholder: "Search within 3 miles...",
        detailMapSearchPlaceholderExact: "Exact Search within 3 miles...",
        detailMapSearchNoMatches: "No matches found within 3 miles",
        detailMapSearchSearching: "Searching for matches within 3 miles...",
        detailMapSearchSearchingExact: "Searching for exact match within 3 miles...",
        globalMap: "Global Map",
        fetchMoreRadios: "Get More Radios",
        radioFetchText: "Showing {radioCount} of {radioTotalCount} radios with valid coordinates",
        radioFetchHiddenText: "Radios hidden by user",
        refreshActive: "Page updates every {refreshRate} minutes, last update: {lastUpdate}",
        refreshPaused: "Automatic refresh paused",
        mapView: "Map View",
        mapSelection: {
            routeAll: "Uplink Route Last {routeRetention} Days",
            route: "Uplink Route Last Day",
            nearby: "Nearby",
            downlinkRouteAll: "Downlink Route Last {routeRetention} Days",
            downlinkRoute: "Downlink Route Last Day"
        },
        mapViewTop10: {
            top10: "Top 10",
            all: "All"
        },
        infoBox: {
            channel: "Channel",
            towersHeardDaily: "Base Stations Heard",
            routeCountDaily: "Uplink Route Count",
            bestTowerHeard: "Best Uplink Base Station",
            bestTowerDownlink: "Best Downlink Base Station",
            routes: "Uplink Routes",
            routeName: "Uplink Route",
            downlinkRouteName: "Downlink Route",
            routeDestinationName: "Uplink Route Destination",
            routeDestinationId: "Uplink Route Destination - {id}",
            routeSourceId: "Downlink Route Source - {id}",
            routeLastUsedDateTime: "Last Used:  {lastUsedDateTime}",
            frequency: "Frequency",
            frequencyName: "Frequency Name",
            lastUsed: "Last Used",
            lastUpdated: "Last Updated",
            lastL2ACK: "Last L2 ACK",
            lastFiveRoutes: "Last 5 Used",
            avgUsageCount: "Usage Count Avg Daily",
            signalStrength: "Signal Strength Avg Daily",
            SNR:"SNR Avg Daily",
            baseStationId: "Base Station ID: ",
            baseStationNoName: "TGB #{id} - Unnamed",
            baseStationType: "Base Station Type: ",
            baseStationLastHeardDateTime: "Last Heard:  {lastHeardDateTime}",
            endpointId: "Endpoint ID: ",
            endpointIdWithRepId: "Endpoint ID: #{id}",
            endpointType: "Device Type:  {endpointDeviceType}",
            endpointReceiveMode: "Receive / Transmit mode:  {receiveMode}",
            endpointLastHeardDateTime: "Last Heard:  {lastHeardDateTime}",
            endpointRIS: "Read Performance:  {ris}",
            notAvailable: "Not Available",
            selectedItems: "Selected Items",
            kfactor: "K-Factor",
            xmitSlot: "Transmit Slot",
            random: "Random",
            cluster: {
                clusterNum: "Number of Items: ",
                clusterName: "Cluster",
                clusterNumDynamic: "Number of Items:  {numItems}",
                zoomToViewMore: "Zoom in to view more details"
            },
            locationEstimated: "location estimated",
            distance: "Distance",
            miles: "miles",
            distanceBetweenInMiles: "Distance {distance} miles",
            bullseyeTitle: "Show distances of 1, 3, 5 and 10 miles",
            routesCount: "Uplink Routes: {count}",
            baseStationsCount: "Base Stations: {count}",
            radiosCount: "Radios: {count}",
            clustersCount: "Clusters: {count}",
            towerSectorInfo: "{startingAzimuth}° - {endingAzimuth}° ({sector})"
        },
        mapViewHelp: {
            routeTitle: "Map View - Route",
            routeSubTitle30: "Last {routeRetentionDays} Days: Routes used in last {routeRetentionDays} days.",
            routeSubTitleDaily: "Last Day: Routes used in last completed calendar day.",
            nearbyTitle: "Map View - Nearby",
            snrArrowHelpText: "The shade of gray is related to SNR. The higher the average SNR, the darker the color gray used.",
            routesUsedHelpText: "The width of the route arrow is related to the number of times used, the wider the line, the higher the number of times used.",
            nearbyHelpText: "Nearby view will show Base Stations and Radios in a three mile radius.",
            top3rd: "Top 3rd",
            middle3rd: "Middle 3rd",
            bottom3rd: "Bottom 3rd",
            mostUsedRoute: "Most used route",
            top10Toggle: "The toggle can be used to switch between the normal view of all routes and only the top 10 (based on SNR) routes."
        },
        mapDrawingHelp: {
            drawingHelpTitle: "Actions Help",
            drawingHelpBody: "This menu contains different actions that allow you to select radios and base stations, clear your drawings and all selection items, and add all selected items to a Set.",
            selectByPolygon: "Use your left mouse button to create the different point in a polygon to select radios and base stations.  Right click anywhere on the map to finish.",
            selectByDrawing: "Press and hold the left mouse button and move your mouse to start drawing to select radios and base stations.  Once you are done just release the left mouse button.",
            clearDrawingSelected: "This will clear any drawing you created, along with clearing all selected items.",
            createSet: "Take all selected items and add them to a new Set.",
            addToSet: "Take all selected items and add them to an existing Set."
        },
        mapOverlay: {
            overlayTitle: "Too Many Map Items to Display",
            overlayText: "Zoom in or add a radio filter to view radios."
        },
        detailActionsSubTitle: 'Map Actions'
    }
}
